import { createContext, useState } from "react";

const ModalContext = createContext({
  isDisable: false,
  setIsDisable: (data) => {},
});

export const ModalContextProvider = (props) => {
  const [data, setData] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  return (
    <ModalContext.Provider
      value={{ isDisable: data, setIsDisable: handleData }}
    >
      {props.children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
